import React, { useState, useEffect, Suspense, Fragment, useMemo } from "react";
import { useClient } from "../../shared/hooks/client-hook";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import handleMaterial from "../../shared/components/three/handleMaterials";
import ModelInstance from "./ModelInstance";
import { useThree } from "@react-three/fiber";

const ModelInstansiator = () => {
  const { client, editor, setCamPos } = useClient();
  const [models, setModels] = useState(null);

  const loader = new GLTFLoader();

  function getModels() {
    if (!editor || !editor.models) {
      return;
    }

    const modelCategories = Object.values(editor.models);
    const newModels = {};

    Object.keys(modelCategories).forEach((categoryId) => {
      const category = modelCategories[categoryId];

      let modelsToLoad = Object.values(category).length;

      Object.values(category).forEach((mdl) => {
        loader.load(mdl.url, (mdlData) => {
          mdlData.scene.traverse((child) => {
            if (child.type === "Mesh" || child.type === "SkinnedMesh") {
              const newMaterial = handleMaterial(child);
              child.material = newMaterial;
            }
          });

          newModels[mdl.id] = mdlData;
          modelsToLoad--;

          if (modelsToLoad === 0) {
            setModels(newModels);
          }
        });
      });
    });
  }

  useEffect(() => {
    if (!editor) {
      return;
    }

    getModels();
  }, [editor]);

  return (
    <Suspense fallback={null}>
      <group>
        {models &&
          client.models &&
          Object.keys(client.models).map((categoryId) => {
            const category = client.models[categoryId];

            return (
              <Fragment key={categoryId}>
                {Object.values(category).map((instance) => {
                  return (
                    <ModelInstance
                      key={instance.id}
                      model={models[instance.model]}
                      instance={instance}
                      setCamPos={setCamPos}
                    />
                  );
                })}
              </Fragment>
            );
          })}
      </group>
    </Suspense>
  );
};

export default ModelInstansiator;
